import { unregister } from "./registerServiceWorker";
import App from "app";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

unregister();
ReactDOM.render(<App />, document.getElementById("root"));

// Hot reload app (requires Webpack or Browserify HMR to be enabled)
if (module.hot) {
  module.hot.accept("app", () => {
    ReactDOM.render(<App />, document.getElementById("root"));
  });
}



// WEBPACK FOOTER //
// ./src/index.js